export default __webpack_public_path__ + "static/media/flower-interstitial-mobile-bg.93b0f36c.png";